/**
 * Operations / dispatch — routes inside the platform shell.
 *
 *   erp/dispatch            pending orders, dispatches, overrides, customer batches, summary
 *   erp/dispatch/new        create a draft (optionally ?so=<sales order id>)
 *   erp/dispatch/:id        one dispatch and its lifecycle actions
 *   erp/dispatch/:id/edit   edit a draft
 */
import { lazy } from 'react';
import type { ReactElement } from 'react';
import { Route } from 'react-router-dom';
import { RequirePermission } from '@/components/shared/RequirePermission';

const DispatchHomePage = lazy(() => import('./DispatchHome').then((m) => ({ default: m.DispatchHomePage })));
const DispatchFormPage = lazy(() => import('./DispatchForm').then((m) => ({ default: m.DispatchFormPage })));
const DispatchDetailPage = lazy(() => import('./DispatchDetail').then((m) => ({ default: m.DispatchDetailPage })));

const M = 'erp.dispatch';

export function dispatchRoutes(): ReactElement[] {
  return [
    <Route key="erp-dispatch" path="erp/dispatch"
      element={<RequirePermission module={M} what="dispatch"><DispatchHomePage /></RequirePermission>} />,
    <Route key="erp-dispatch-new" path="erp/dispatch/new"
      element={<RequirePermission module={M} action="create" what="new dispatches"><DispatchFormPage /></RequirePermission>} />,
    <Route key="erp-dispatch-view" path="erp/dispatch/:id"
      element={<RequirePermission module={M} what="dispatch"><DispatchDetailPage /></RequirePermission>} />,
    <Route key="erp-dispatch-edit" path="erp/dispatch/:id/edit"
      element={<RequirePermission module={M} action="edit" what="dispatch drafts"><DispatchFormPage /></RequirePermission>} />,
  ];
}
